module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3NpTw"))).then(() => parcelRequire('ljYL6'));